import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon,DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, PaperClipIcon} from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import EightDreport from "../print/EightDreport";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { LocaleContext } from '../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { emitMeasureGroupListMutation } from '../../utils/measureGroupListSync';
import { appendMeasureWriteFormData } from '../../utils/measureWriteFormData';
import { uiT as t } from '../../utils/uiTranslate';

export default function DocumentationAdd({measure,name,type}) {
    
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,visible,openFilePreview} = useContext(UtilContext);
    const {locale, t} = useContext(LocaleContext);

    const [recordProcessorDepartment, setRecordProcessorDepartment] = useState();
    const [recordProcessors, setRecordProcessors] = useState([]);
    const [images,setImages] = useState('');

    const [formDocumentation,setFormDocumentation] = useState(measure);
    const [documentationRecordType, setDocumentationRecordType] = useState(type);
    const [fileList, setFileList] = useState([]);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add otk-documentation") || measure.contractor_id==user.employee.id)?false:true);
    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [scrollIcons,setScrollIcons] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);

    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);
    const componentRef = useRef(null);
    const fileListRef = useRef(null);
    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

    useEffect(() => {
        // Update the document title using the browser API
        if(formDocumentation!=null){
            filterRecordProcessors(formDocumentation.contractor.department_id);
        }
        else{
            if(user?.employee?.id && type=="add"){
                filterRecordProcessors(user.employee.department_id);
                formik.setFieldValue('contractor_id',user.employee.id);
            }
        }
        if(type=="edit")getImages();
    },[formDocumentation]);

    function getImages(id){
        getRequest(`/api/measures/images/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }

    /* validate form */
    const validate = values => {
        const errors = {};
        return errors;
    };

    /* form for adding error record */
    const formik = useFormik({
        initialValues: formDocumentation==null?{
            article_number: '',order_number:'',contractor_id:'',type:name,
            total_amount:'',measure_complexity_id:'',protocol_type_id:''
        }:formDocumentation,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            appendMeasureWriteFormData(formData, values);
            for(let i = 0;i<fileList.length;i++){
                //console.log("IMAGE :"+fileList[i].name);
                formData.append('files[]',fileList[i]);
            }
            if(documentationRecordType=="add"){
                setDialogText(t('Common.Saving'));
                setVisible(true);
                postRequest('/api/measures', formData,true)
                .then((response) => {
                    formik.setValues(response.data);
                    //setDocumentationRecordType("edit");
                    let url = "";
                    if(name== 'DOKUMENTÁCIA'){
                        url = "/api/measure/documentation";
                    }
                    else if(name=="SEBAKONTROLA"){
                        url = "/api/measure/selfControl";
                    }
                    else if(name== 'MERACÍ PROTOKOL'){
                        url = "/api/measure/measurementProtocol";
                    }
                    else if(name=="NDT PROTOKOL"){
                        url = "/api/measure/NDTProtocol";
                    }
                    else if(name== 'ŽÍHACÍ PROTOKOL'){
                        url = "/api/measure/annealingProtocol";
                    }
                    if(fileList.length){
                        getImages(response.data.id);
                        setFileList([]);
                        fileListRef.current.value = null;
                    }
                    setDialogText(t('Common.Loading'));
                    getRequest(url).then((response) => {
                        if(name== 'DOKUMENTÁCIA'){
                            dispatch({type:'load_documentation',newDocumentation:response.data});
                        }
                        else if(name=="SEBAKONTROLA"){
                            dispatch({type:'load_self_control',newSelfControl: response.data});
                        }
                        else if(name== 'MERACÍ PROTOKOL'){
                            dispatch({type:'load_measurement_protocol',newMeasurementProtocol: response.data});                        }
                        else if(name=="NDT PROTOKOL"){
                            dispatch({type:'load_ndt_protocol',newNDTProtocol: response.data});
                        }
                        else if(name== 'ŽÍHACÍ PROTOKOL'){
                            dispatch({type:'load_annealing_protocol',newAnnealingProtocol: response.data});
                        }
                        emitMeasureGroupListMutation({
                            operation: 'create',
                            measureType: name,
                            order_number: formik.values?.order_number ?? values?.order_number ?? null,
                        });
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    }).catch((reason) => {
                        setVisible(false);
                        alert(t('Common.Toast.ActionFailedDetail'));
                    });
                }).catch((reason) => {
                    setVisible(false);
                    alert(t('Common.Toast.ActionFailedDetail'));
                });
            }
            else{
                postRequest(`/api/measures/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/measures").then((response) => {
                        dispatch({type:'load_measures',newErrorRecords:response.data});
                        emitMeasureGroupListMutation({
                            operation: 'update',
                            measureType: name,
                            order_number: formik.values?.order_number ?? values?.order_number ?? null,
                        });
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        dispatch({type:'measures_reload',value:true});
                        formik.setValues(values);
                        if(fileList.length){
                            getImages();
                            setFileList([]);
                            fileListRef.current.value = null;
                        }
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    function addNewDocRecord(){
        dispatch({type:'create_new_tab',name: t('Otk.AddDocumentation'), translationKey: 'Otk.AddDocumentation', legacyLabel: t('Otk.AddDocumentation'),page:'DocumentationAdd',props:{measure: null,name:t('Otk.DocType.Documentation'),type:'add',not_last_used: true},mask:'qlty009'})
    }

    function copyDocRecord(){
        dispatch({type:'create_new_tab',name: t('Otk.AddDocumentation'), translationKey: 'Otk.AddDocumentation', legacyLabel: t('Otk.AddDocumentation'),page:'DocumentationAdd',props:{measure: formik.values,name:t('Otk.DocType.Documentation'),type:'add',not_last_used: true},mask:'qlty009'})
    }


    /* filter record processors by department in form */
    function filterRecordProcessors(departmentId){
        setRecordProcessorDepartment(departmentId);
        setRecordProcessors(state.employees
        .filter(employee => employee.department.id === parseInt(departmentId)));
    }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.error_records_int, formDocumentation?.id, setFormDocumentation),
        [state.error_records_int, formDocumentation?.id]
    );

      const accept = (id) => {
          getRequest(`/api/measures/deleteImage/${id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('DocumentationAdd.Toast.FileDeleted') });
                getImages();
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('DocumentationAdd.Toast.FileDeleteFailed'), life: 3000 });
              })
        };

        const reject = () => {
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
        }
    

    function deleteFiles(img){
        confirmDialog({
            message: t('DocumentationAdd.Confirm.DeleteFileMessage'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => accept(img.id)
        });
    }

    return (
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewDocRecord()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyDocRecord()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => handlePrint()}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Otk.AddDocumentation'),"Documentation Add")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("DocumentationAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><VerticalLineIcon/></div>
          </IntersectionObserverWrapper>
        </div>
        <div className='overflow-y-auto h-[calc(100vh-177px)] bg-gray-100'>
        <form onSubmit={formik.handleSubmit}>
       <div className="relative flex flex-col justify-left overflow-x">
          <div className="xl:grid grid-cols-2 gap-1 mb-2 ">
          <div className={`w-auto p-6 m-4 bg-white rounded-md shadow-lg`}>
                <h1 className="text-2xl font-semibold text-left text-zinc-900">
                   {name}
                </h1>
                {documentationRecordType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                <div className="mt-6">
                    <div>
                      <div>
                        <label
                            htmlFor="article_number"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Artikel
                        </label>
                        <input
                            name='article_number'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.article_number}
                            className={`bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="order_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Zakazka')}</label>
                        <input
                            name='order_number' required
                            type="text"
                            onChange={formik.handleChange} value={formik.values.order_number}
                            className={`bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                    </div>
                    <div>
                    <div className='grid grid-cols-2 gap-1'>
                    <div>
                        <label
                            htmlFor="recordProcessorDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.RequesterDepartment')}</label>
                        <select 
                        name='recordProcessorDepartment'
                        onChange={(e) => filterRecordProcessors(e.target.value)} value={recordProcessorDepartment}
                        className={`bg-whiteblock w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          {state.departments.map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="contractor_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.RequesterName')}</label>
                        <select 
                        name="contractor_id"
                        onChange={formik.handleChange} value={formik.values.contractor_id}
                        className={`bg-whiteblock w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectEmployee')}</option>
                          {recordProcessors.map((recordProcessor) => (
                            <option key={recordProcessor.id} value={recordProcessor.id}>{recordProcessor.name}</option>
                            ))}
                        </select>
                        </div>
                        </div>
                    </div>
                {name== 'DOKUMENTÁCIA' && <>
                <div className='grid grid-cols-2 gap-1'>
                    <div className='w-full mb-2'>
                    <label htmlFor='total_amount' className='font-semibold'>
                        Počet kusov:
                        <input 
                        onChange={formik.handleChange} value={formik.values.total_amount}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                        type='number'
                        name='total_amount'></input>
                    </label>
                </div>
                <div className='w-full mb-2'>
                    <label htmlFor='measure_complexity_id' className='font-semibold'>{t('Ui.R67.Narocnost_dielu')}</label>
                        <select required
                        onChange={formik.handleChange} value={formik.values.measure_complexity_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                        name="measure_complexity_id">
                            <option value="">{t('Ui.R67.SelectDifficulty')}</option>
                            {state.measure_complexities.map((complexity) => (
                            <option key={complexity.id} value={complexity.id}>{complexity.category + " - " + complexity.description[locale]}</option>
                            ))}
                        </select>
                </div>
                </div>
                </>}
                {(name==="NDT PROTOKOL") && <>
                <div className='grid grid-cols-2 gap-1'>
                    <div className='w-full mb-2'>
                        <label htmlFor='protocol_type_id' className='font-semibold'>
                            Druh protokolu:
                            </label>
                            <select required
                            onChange={formik.handleChange} value={formik.values.protocol_type_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            name="protocol_type_id">
                                <option value="">{t('Ui.R67.Vyber_druh_protokolu')}</option>
                                {state.protocol_types.map((protocol_type) => (
                                    <option key={protocol_type.id} value={protocol_type.id}>
                                    {protocol_type.name[locale] || protocol_type.name?.sk} 
                                    </option>
                                ))}
                            </select>
                    </div>
                </div>
                </>}
                <div>
                    <label
                        htmlFor="files"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Subory')}</label>
                    <input
                    accept='image/*,application/pdf'
                    name='files' 
                    ref={fileListRef}
                    onChange={handleFileChange}
                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                    type='file'
                    multiple="multiple"
                    id='file'/>
                </div>
                {documentationRecordType=="edit" && <div>
                    <label
                        htmlFor="images"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Prilohy')}</label>
                    {images!=='' && images.map((img) => (<table className='w-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                        <tr>
                            <td className='text-black h-10'><div className='flex flex-row p-2'>
                                <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                    <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>
                                </div>
                                    <div className='flex flex-col ml-4'>
                                    <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                    <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                    </div>
                                </div></td>
                        </tr>
                    </table>))}
                    </div> }   
                </div>          
            </div>       
            </div>
            <div>
            <input
                name='type'
                type="hidden"
                value={formik.values.type}
            />
            <button type="submit" ref={submitRef} className='hidden'></button>
            {/*<button type="submit" className='w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Common.SaveUpper')}</button>*/}
            </div>
        </div>
        </form>
        </div>
        </>
    );
}